var env = process.env.NODE_ENV;

var facebook = (function() {

    var _init = function(cb){
        if(typeof window.FB === 'undefined'){
            window.fbAsyncInit = function(){
                window.FB.init({
                    appId: env !== 'production' ? '1824084034479944' : '1824082947813386',
                    cookie: true,  // enable cookies to allow the server to access the session
                    xfbml: false,  // parse social plugins on this page
                    version: 'v2.8' // use version 2.1
                });
                cb && cb();
            };

            // Load the SDK asynchronously
            (function(d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s); js.id = id;
                js.src = "//connect.facebook.net/en_US/sdk.js";
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));
        }else{
            cb && cb();
        }
    }

    return {
        init: _init
    };

})();

module.exports = facebook;



// WEBPACK FOOTER //
// ./src/common/utils/facebook.js